import React, { useRef, useState } from 'react';
import * as mobxReact from 'mobx-react';
import classnames from 'classnames';
import Text from '../../../../../../global/text/text';
import ChevronSVG from '../../../../../../../images/svg/icons8-expand-arrow';
import { Popover } from '../../../../../../global/popover/popover';
import { OpenMessageIcon } from '../../../../../../global/icons/icons';
import {
    BOOKABLE_MEETING_CALENDAR_INVITATION,
    MEETINGN_CALENDAR_INVITATION,
    PRESENTER_BOOKABLE_MEETING_CALENDAR_INVITATION,
    REGISTRATION_CALENDAR_INVITATION
} from '../emails-template-form.texts';
import './emails-template-form-header.scss';

export interface EmailsTemplateFormHeaderHeaderProps {
    options: string[];
    selectedOption: string;
    setSelectedOption: (el: string) => void;
    handleSendPreview: () => void;
    errorMessage: string;
    isCreatedEmail: boolean;
}


export const EmailsTemplateFormHeader = mobxReact.observer(((props: EmailsTemplateFormHeaderHeaderProps) => {
    const {
        options,
        selectedOption,
        setSelectedOption,
        handleSendPreview,
        errorMessage,
        isCreatedEmail,
    } = props;

    const [isStatusModalOpen, setStatusModalOpen] = useState(false);
    const statusButtonRef = useRef(null);
    const hideSendPreview = selectedOption === REGISTRATION_CALENDAR_INVITATION
        || selectedOption === MEETINGN_CALENDAR_INVITATION
        || selectedOption === BOOKABLE_MEETING_CALENDAR_INVITATION
        || selectedOption === PRESENTER_BOOKABLE_MEETING_CALENDAR_INVITATION
        || isCreatedEmail;

    return (
        <div className='oe-popup-layout__header emails-template-form-layout'>
            <div className='emails-template-form-header'>
                <div className='emails-template-form-header__item'>
                    <div
                        className={classnames('emails-template-form-header__dropdown')}
                        ref={statusButtonRef}
                    >
                        <div className='emails-template-form-header__wrapper' onClick={() => setStatusModalOpen(true)}>
                            <div className='emails-template-form-header__team'>
                                <Text
                                    message={selectedOption.toString()}
                                    withEllipsis
                                />
                                <ChevronSVG />
                            </div>
                        </div>
                        <Popover
                            padding={0}
                            isOpen={isStatusModalOpen}
                            buttonRef={statusButtonRef}
                            onClickOutside={() => setStatusModalOpen(false)}
                            customWidth={statusButtonRef.current?.getBoundingClientRect().width * 1.7}
                            position='bottom'
                            align='start'
                        >
                            <div className='emails-template-form-header__options'>
                                {options.map((el, index) =>
                                    <div
                                        className={classnames('emails-template-form-header__option', {
                                            'emails-template-form-header__option--selected': selectedOption === el
                                        })}
                                        key={el}
                                        onClick={() => {
                                            setSelectedOption(el);
                                            setStatusModalOpen(false);
                                        }}
                                    >
                                        <Text
                                            id={index.toString()}
                                            message={el}
                                            withEllipsis
                                        />
                                    </div>
                                )}
                            </div>
                        </Popover>

                    </div>
                </div>
                <div className='emails-template-form-header__item'>
                    {
                        !hideSendPreview &&
                        <div className={'send-preview'} onClick={handleSendPreview}>
                            <OpenMessageIcon/>
                            <Text className={'send-preview-text'} message='Send Preview'/>
                        </div>
                    }
                </div>
            </div>
            <Text
                className={classnames(
                    'oe-form-field__error',
                    'emails-template-form-header__error',
                )}
                message={errorMessage}
                tag='div'
            />
        </div>
    );
}));
